import { rateLineProposalListQuerySchema, type RateLineProposalListQuery } from '@chukua/common';
import { useCallback } from 'react';
import { useListQuery } from '../../../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../../../shared/hooks/use-paged-list';
import { listCardProposals } from '../../../rate-cards.api';

/** One card's proposals, whatever their status, for the URL's list query. */
export function useCardProposals(rateCardId: string) {
  const list = useListQuery(rateLineProposalListQuerySchema);
  const load = useCallback((query: RateLineProposalListQuery) => listCardProposals(rateCardId, query), [rateCardId]);
  return { list, ...usePagedList(list.query, load) };
}
